import React, { useContext } from "react";
import { ThemeContext } from "../App";

export default function ConfirmModal({
  isOpen,
  title,
  message,
  onClose,
  actions = [],
}) {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";

  if (!isOpen) return null;

  return (
    <div style={styles.overlay}>
      <div
        style={{
          ...styles.modal,
          background: isDark ? "#1e1e1e" : "#ffffff",
          color: isDark ? "#f1f1f1" : "#222222",
          boxShadow: isDark
            ? "0 10px 30px rgba(0,0,0,0.6)"
            : "0 10px 30px rgba(0,0,0,0.2)",
          border: isDark ? "1px solid #333" : "1px solid #ddd",
        }}
      >
        <h2
          style={{
            ...styles.title,
            textAlign: "center",
            color: isDark ? "#ffffff" : "#111111",
          }}
        >
          {title}
        </h2>

        <p
          style={{
            ...styles.message,
            color: isDark ? "#d0d0d0" : "#444444",
          }}
        >
          {message}
        </p>

        <div style={styles.actions}>
          {actions.map((action, index) => (
            <button
              key={index}
              onClick={action.onClick}
              style={{
                ...styles.button,
                backgroundColor: action.color || "#007bff",
              }}
            >
              {action.label}
            </button>
          ))}
        </div>

        <button
          onClick={onClose}
          style={{
            ...styles.close,
            color: isDark ? "#ffffff" : "#222222",
            background: isDark ? "#2b2b2b" : "transparent",
          }}
        >
          ✕
        </button>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },
  modal: {
    padding: "20px",
    borderRadius: "10px",
    width: "400px",
    maxWidth: "90%",
    position: "relative",
    transition: "all 0.2s ease",
  },
  title: {
    marginBottom: "10px",
  },
  message: {
    marginBottom: "20px",
    lineHeight: "1.5",
  },
  actions: {
    display: "flex",
    gap: "10px",
    justifyContent: "flex-end",
    flexWrap: "wrap",
  },
  button: {
    border: "none",
    padding: "10px 15px",
    borderRadius: "6px",
    color: "#fff",
    cursor: "pointer",
    fontWeight: "bold",
  },
  close: {
    position: "absolute",
    top: "10px",
    right: "10px",
    width: "36px",
    height: "36px",
    border: "none",
    borderRadius: "50%",
    fontSize: "18px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};